import { triggerMergeCartOnLogin } from 'src/scripts/utils/cart/cart-apis';
import '../../../styles/templates/customers/account.scss';
import '../../../styles/templates/customers/order-details.scss';
import './account/runShopByColor';
import { InitOrderHistory } from '../_shared/ui-components/Account/OrderHistory';
import { InitAccountMenu } from '../_shared/ui-components/Account/AccountMenu';

(async function () {
  function isAllowedReferrer(referrer: string | null): boolean {
    if (!referrer) {
      return false;
    }
    try {
      const url = new URL(referrer);
      const hostname = url.hostname.toLowerCase();
      if (hostname.endsWith('.aloyoga.com') || hostname.includes('www.alo')) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  if (!isAllowedReferrer(document.referrer)) {
    var returnUrl = window.sessionStorage.getItem('social-login-return-url');
    if (returnUrl) {
      await triggerMergeCartOnLogin();
      window.sessionStorage.removeItem('social-login-return-url');
      if (returnUrl === '/account') return;

      // ? why can this not just be the `returnUrl`
      // - in the interim we will do the following check
      let redirectUrl = returnUrl.includes(window.location.origin)
        ? returnUrl
        : window.location.origin +
          // ? is this need given we checking for the origin above?
          (returnUrl[0] === '/' ? returnUrl : '/' + returnUrl); // XXS protection

      window.location.href = redirectUrl;
    }
  }
})();

window.addEventListener('DOMContentLoaded', () => {
  InitOrderHistory();
  InitAccountMenu();
});
